<template>
    <!-- Reservas realizadas: el diseño y la lógica están en ReservasCuenta. -->
    <ReservasCuenta tipo="realizadas" />
</template>

<script>
import ReservasCuenta from '@/components/Cuenta/ReservasCuenta.vue';

export default {
    name: 'MadeReservationsList',
    components: { ReservasCuenta },
};
</script>

<style src="../../components/BankInformation/bkCuenta.css"></style>
<style src="../../components/Cuenta/cuentaMenu.css"></style>
